import { Component, OnInit } from '@angular/core';
import { JobService } from 'src/app/services/job.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ActivatedRoute } from '@angular/router';
import { JobStatus, SourceType, JobSortType, JobCriteria } from 'src/app/common';

@Component({
  selector: 'app-instagram',
  templateUrl: './instagram.component.html',
  styleUrls: ['./instagram.component.scss']
})
export class InstagramComponent implements OnInit {
  constructor(private jobService: JobService, private spinner: SpinnerService, private route: ActivatedRoute) { }
  Object = Object;

  tab = 'image';
  jobs: any[] = [];
  trusteds: string[] = [];
  total: number;
  from = 0;
  limit = 100;
  user: string;
  users: { [key: string]: number } = {};

  JobStatus = JobStatus;

  async ngOnInit() {
    await new Promise<void>(resolve => {
      this.route.queryParams.subscribe(async params => {
        this.from = params.from;
        await this.load();
        resolve();
      });
    });
  }

  keyword = '';
  criteria: JobCriteria;
  async load(payload?: string | any) {
    this.spinner.show();
    if (typeof (payload) == 'string') {
      this.user = payload;
      this.from = 0;
    } else { this.from = payload ? payload.from : 0; }

    this.criteria = <JobCriteria>{
      Statuses: [JobStatus.Pending],
      IsExpired: false,
      SourceType: SourceType.Instagram,
      Sort: JobSortType.UpdateTime,
      Keyword: this.keyword
    };
    if (this.user) this.criteria.SourceName = this.user;

    if (payload == undefined) {
      this.trusteds = (await this.jobService.getIndexData({ Type: 'Instagram', Subtype: 'TRUSTED' })).map(_ => _.Identifier);
      this.users = await this.jobService.aggregate(this.criteria, 'sourceName.keyword', 200);
    }

    const result = await this.jobService.admin_search(this.criteria, this.from, this.limit);

    this.jobs = result.jobs;
    this.total = result.total;

    this.spinner.hide();
  }

  async setStatus(id: string, status: JobStatus, i?: number, event?: MouseEvent) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    var data = { State: this.jobs[i].State, City: this.jobs[i].City };
    this.jobs.splice(i, 1);
    let process = (status == JobStatus.Started);
    await this.jobService.setStatusByAdmin(id, status, data, process);
    if (!this.jobs.length) {
      await this.load(this.total > this.limit ? { from: this.from } : '');
    }
  }

  async rejectAll() {
    await this.jobService.rejectByCriteria(this.criteria);
    delete this.keyword;
    await this.load();
  }

  async saveIndex(key: string, subType: string) {
    key = key.replace('@', '');
    if (subType == 'BLOCKED') {
      if (!confirm('تمام آگهی های تایید نشده ی این صفحه مرجوع میشوند. مورد تایید است؟')) return;
      delete this.users[key];
      delete this.users['@' + key];
      delete this.user;
    }
    await this.jobService.setIndexData({ Identifier: key, Type: 'Instagram', Subtype: subType, Data: {} });
    await this.load();
  }

  // async refine() {
  //   this.spinner.show();
  //   await this.jobService.refineInstagram(JobStatus.Pending);
  //   await this.load();
  //   this.spinner.hide();
  // }

  trackByFn(index: any, item: any) { return item.Id; }
}
